module.exports = __webpack_public_path__ + "media/bootstrap-icons/broadcast-pin-72655bc9.svg";